export interface Dataset {
    name: string
    title: string
    md?: string | (() => Promise<string | typeof import("*.md")>) // 通常是通过异步require引入一个markdown文件。（利用了markdown-loader包，实际上require markdown文件得到的就是一段html字符串，因此理论上，这里填写markdown字符串也是没有任何问题的）
    href?: string
    abstract?: string
    img?: string
    tag?: { content: string, color: string }
}

function state() {
    const datasets: Dataset[] = [
        {
            name: "CLOC",
            title: "Cross-domain Large-scale Object Counting Dataset",
            md: () => import(/* webpackChunkName: "CLOC" */ '../data/dataset/CLOC/README_en.md'),
            img: require("../assets/data/cloc.png"),
            tag: { content: "220K images · 15M instances", color: "#00695c" }
        },
        {
            name: "NeurologyCrop",
            title: "A Neurology Benchmark for Hypergraph-Driven Retrieval-Augmented Generation",
            md: () => import(/* webpackChunkName: "NeurologyCrop" */ '../data/dataset/NeurologyCrop/README_en.md'),
            img: require("../assets/research area/hyperrag.svg"),
            tag: { content: "Hyper-RAG", color: "#6a1b9a" }
        },
        {
            name: "THU-EHROccIR",
            title: "Event-enhanced High-Resolution Occluded Image Reconstruction Dataset",
            md: () => import(/* webpackChunkName: "THU-EHROccIR" */ '../data/dataset/THU-EHROccIR/dataset.md'),
            img: require("../assets/data/eoccsr.png"),
        },
        {
            name: "THU-DepthQA",
            title: "Depth Quality Assessment dataset",
            md: () => import(/* webpackChunkName: "THU-DepthQA" */ '../data/dataset/THU-DepthQA/数据集介绍.md'),
            img: require("../assets/data/depthqa.png"),
        },
        {
            name: "THU-HSEVI",
            title: "THU-HSEVI: High-Speed Event-Enhanced Video Frame Interpolation Dataset",
            md: () => import(/* webpackChunkName: "THU-HSEVI" */ '../data/dataset/THU-HSEVI/HSEVI.md'),
            img: require("../assets/data/hsevi.png"),
        },
        {
            name: "THU-EOccDE",
            title: "Event-enhanced Occluded scene Depth Estimation dataset",
            md: () => import(/* webpackChunkName: "THU-EOccDE" */ '../data/dataset/THU-EOccDE/dataset.md'),
            img: require("../assets/data/thu-eoccde.png"),
        },
        {
            name: "THU-EACT-50",
            title: "THU-EACT-50: A Real-World Event-Based Action Recognition Benchmark",
            md: () => import(/* webpackChunkName: "THU-EACT-50" */ '../data/dataset/THU-EACT-50/README.md'),
            img: require("../assets/data/thu-eact50.png"),
        },
        {
            name: "Open-Set 3D Object Retrieval",
            title: "OS-MN40, OS-MN40-Miss, OS-MN40-core, OS-NTU-core, OS-ESB-core",
            href: "/os3dor",
            img: require("../assets/data/os3dor.jpg")
        },
        {
            name: "THU-MV-EACT-50",
            title: "THU-MV-EACT-50",
            md: () => import(/* webpackChunkName: "THU-EACT-50" */ '../data/dataset/THU-MV-EACT-50/README.md'),
            img: require("../data/dataset/THU-MV-EACT-50/figures/dataset-v2-env.png"),
        },
    ]
    const datasets_zh: Dataset[] = [
        {
            name: "CLOC",
            title: "跨域大规模目标计数数据集",
            md: () => import(/* webpackChunkName: "CLOC-zh" */ '../data/dataset/CLOC/README.md'),
            img: require("../assets/data/cloc.png"),
            tag: { content: "22 万图像 · 1500 万实例", color: "#00695c" }
        },
        {
            name: "NeurologyCrop",
            title: "面向超图检索增强生成的神经科学评测数据",
            md: () => import(/* webpackChunkName: "NeurologyCrop-zh" */ '../data/dataset/NeurologyCrop/README.md'),
            img: require("../assets/research area/hyperrag.svg"),
            tag: { content: "Hyper-RAG", color: "#6a1b9a" }
        },
        {
            name: "THU-EHROccIR",
            title: "事件增强遮挡高分辨率图像重建数据集",
            md: () => import(/* webpackChunkName: "THU-EOccSR" */ '../data/dataset/THU-EHROccIR/dataset.md'),
            img: require("../assets/data/eoccsr.png"),
        },
        {
            name: "THU-DepthQA",
            title: "深度质量评估数据集",
            md: () => import(/* webpackChunkName: "THU-DepthQA" */ '../data/dataset/THU-DepthQA/数据集介绍.md'),
            img: require("../assets/data/depthqa.png"),
        },
        {
            name: "THU-HSEVI",
            title: "高速事件增强视频帧插值数据集",
            md: () => import(/* webpackChunkName: "THU-HSEVI" */ '../data/dataset/THU-HSEVI/HSEVI.md'),
            img: require("../assets/data/hsevi.png"),
        },
        {
            name: "THU-EOccDE",
            title: "事件增强遮挡场景深度估计数据集",
            md: () => import(/* webpackChunkName: "THU-EOccDE" */ '../data/dataset/THU-EOccDE/dataset.md'),
            img: require("../assets/data/thu-eoccde.png"),
        },
        {
            name: "THU-EACT-50",
            title: "THU-EACT-50: 基于事件数据的动作识别数据集",
            md: () => import(/* webpackChunkName: "THU-EACT-50" */ '../data/dataset/THU-EACT-50/README.md'),
            img: require("../assets/data/thu-eact50.png"),
        },
        {
            name: "开放场景下的立体对象检索",
            title: "OS-MN40, OS-MN40-Miss, OS-MN40-core, OS-NTU-core, OS-ESB-core",
            href: "/os3dor",
            img: require("../assets/data/os3dor.jpg")
        },
        {
          name: "THU-MV-EACT-50",
          title: "THU-MV-EACT-50",
          md: () => import(/* webpackChunkName: "THU-EACT-50" */ '../data/dataset/THU-MV-EACT-50/README.md'),
          img: require("../data/dataset/THU-MV-EACT-50/figures/dataset-v2-env.png"),
        },
    ]
    return { zh: datasets_zh, en: datasets }
}

export default state()
